import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  ImportBumpayPayload,
  BumpaKeyPayload,
  BumpaOrderPayload,
  BumpaIntegrationResponse,
  BumpaOrderResponse,
} from "type/bumpa";

export const bumpa = createApi({
  reducerPath: "bumpa",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    importBumpa: builder.mutation<any, ImportBumpayPayload>({
      query: (body) => ({
        url: `platform-import-order`,
        method: "POST",
        body,
      }),
    }),
    updateBumpaKey: builder.mutation<BumpaIntegrationResponse, BumpaKeyPayload>({
      query: (body) => ({
        url: `platform-integration`,
        method: "POST",
        body,
      }),
    }),
    getBumpaOrders: builder.mutation<BumpaOrderResponse, BumpaOrderPayload>({
      query: (body) => ({
        url: `platform-integration/orders`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useImportBumpaMutation,
  useGetBumpaOrdersMutation,
  useUpdateBumpaKeyMutation,
} = bumpa;
